var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.789062,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#F1F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 29.0889C27.0536 29.0906 26.6201 29.239 26.2661 29.5111C25.9122 29.7832 25.6574 30.164 25.541 30.595C25.4245 31.0259 25.4528 31.4832 25.6216 31.8966C25.7904 32.3099 26.0902 32.6563 26.475 32.8827V35.7889H28.55V32.8827C28.8545 32.7026 29.1071 32.4468 29.2835 32.1401C29.4598 31.8334 29.5538 31.4864 29.5563 31.1327V31.1327C29.5563 30.8632 29.503 30.5964 29.3995 30.3476C29.296 30.0989 29.1443 29.873 28.9532 29.6831C28.7621 29.4931 28.5354 29.3428 28.286 29.2409C28.0365 29.1389 27.7694 29.0873 27.5 29.0889V29.0889Z",
    stroke: "#2698EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1812 24.3955H19.8125C18.3213 24.3955 17.1125 25.6043 17.1125 27.0955V37.7768C17.1125 39.2679 18.3213 40.4768 19.8125 40.4768H35.1812C36.6724 40.4768 37.8812 39.2679 37.8812 37.7768V27.0955C37.8812 25.6043 36.6724 24.3955 35.1812 24.3955Z",
    stroke: "#2698EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8438 24.3953V22.7641C20.8438 20.9971 21.5457 19.3024 22.7952 18.053C24.0446 16.8035 25.7392 16.1016 27.5062 16.1016C29.2733 16.1016 30.9679 16.8035 32.2173 18.053C33.4668 19.3024 34.1687 20.9971 34.1687 22.7641V24.3953",
    stroke: "#2698EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgReset;